import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-760d935d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "sidebar-header"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-angle-left" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-magnifying-glass" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 2,
  class: "sidebar-header-search"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-angle-left" }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 3,
  class: "trailer-results-listing"
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader" }, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 0,
  class: "h-100 d-flex align-items-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AttachTrailerConfirmation = _resolveComponent("AttachTrailerConfirmation")!
  const _component_list_refresh = _resolveComponent("list-refresh")!
  const _component_ExpandableBadge = _resolveComponent("ExpandableBadge")!
  const _component_FbxInput = _resolveComponent("FbxInput")!
  const _component_NoTrailersAvailable = _resolveComponent("NoTrailersAvailable")!
  const _component_LocationTrailerResultCard = _resolveComponent("LocationTrailerResultCard")!
  const _component_fbx_button = _resolveComponent("fbx-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["sidebar", _ctx.customSidebarStyles])
  }, [
    (_ctx.showConfirm)
      ? (_openBlock(), _createBlock(_component_AttachTrailerConfirmation, {
          key: 0,
          trailerNumber: _ctx.trailerNumber,
          trailerCompany: _ctx.trailerCompany,
          onAccept: _ctx.attachTrailer,
          onReject: _ctx.cancelConfirm
        }, null, 8, ["trailerNumber", "trailerCompany", "onAccept", "onReject"]))
      : _createCommentVNode("", true),
    _createVNode(_component_list_refresh, { parentRefreshing: _ctx.isRefreshing }, null, 8, ["parentRefreshing"]),
    (!_ctx.searchTrailer)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_ExpandableBadge),
          _createElementVNode("div", {
            class: "icon-container back-button",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.navigateBack && _ctx.navigateBack(...args)))
          }, _hoisted_3),
          _createElementVNode("div", {
            onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.switchExpand && _ctx.switchExpand(...args)), ["stop"]))
          }, "Trailer Solutions"),
          (!_ctx.searchTrailer && !_ctx.isLoading && _ctx.results.length !== 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "icon-container search-button",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.displaySearchField && _ctx.displaySearchField(...args)))
              }, _hoisted_5))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", {
            class: "icon-container back-button-flex",
            onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeSearchField && _ctx.closeSearchField(...args)), ["stop"]))
          }, _hoisted_8),
          _createVNode(_component_FbxInput, {
            ref: "trailerNumberSearch",
            id: "trailerNumberSearch",
            label: "Trailer Number",
            icon: "fa-solid fa-magnifying-glass",
            "model-value": _ctx.searchFilter,
            "onUpdate:modelValue": _ctx.setSearchFilter
          }, null, 8, ["model-value", "onUpdate:modelValue"])
        ])),
    (_ctx.shouldHideTrailerListing == false)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
            : (_ctx.noResults && !_ctx.searchFilter)
              ? (_openBlock(), _createBlock(_component_NoTrailersAvailable, {
                  key: 1,
                  listView: "selecttrailer"
                }))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.results, (result, index) => {
                  return (_openBlock(), _createBlock(_component_LocationTrailerResultCard, {
                    key: index,
                    result: result,
                    id: result.trailers[0].id,
                    selectedResult: _ctx.selectedResult,
                    onClick: ($event: any) => (_ctx.onRowClick(result))
                  }, null, 8, ["result", "id", "selectedResult", "onClick"]))
                }), 128))
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isLoading || (_ctx.searchFilter && _ctx.noResults))
      ? (_openBlock(), _createElementBlock("div", {
          key: 4,
          class: _normalizeClass(["trailer-results-footer sidebar-footer", { 'no-results': _ctx.noResults || _ctx.shouldHideTrailerListing }])
        }, [
          (_ctx.trailerAssociationsEnabled)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createVNode(_component_fbx_button, {
                  class: "italic",
                  "button-text": _ctx.attachButtonText,
                  theme: "link",
                  onClick: _ctx.navigateTrailerEnter
                }, null, 8, ["button-text", "onClick"])
              ]))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true)
  ], 2))
}